import LiveBoard from '../../features/live/layouts/live';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
// The project filter lives in the query string and the layout reads it.

export default function LivePage() {
    return <LiveBoard />;
}
